import { DashboardPanel } from "components";
import { withLabelsContext, withUserContext } from "context";
import { rgba } from "polished";
import React from "react";
import { Card } from "react-bootstrap";
import { Bubble } from "react-chartjs-2";
import styled, { useTheme } from "styled-components";
import ChartDoughnut from "components/ChartDoughnut/ChartDoughnut";

const StyledChartWrapper = styled.div`
	position: relative;
	padding-left: 20px;
	padding-bottom: 25px;
	canvas {
		//height: 170px !important;
	}
	> div {
		position: absolute;
		font-size: 12px;
		font-weight: 100;
	}
	> div:nth-of-type(1) {
		left: 5px;
		top 50%;
		transform: rotate(-90deg);
		transform-origin: left;
	}
	> div:nth-of-type(2) {
		bottom: 0;
		left: 50%;
		margin-left: 20px;
		transform: translateX(-50%);
	}
`;

const ParentChart = (chartData) => {
  const data02 = [
    chartData.chartData.yet_to_start || 0,
    chartData.chartData.in_progress || 0,
    chartData.chartData.attended || 0,
  ];

  const data = {
    labels: ["Yet to start", "In Progress", "Attended"],
    datasets: [
      {
        label: "Student Progress Chart",
        data: data02,
        backgroundColor: ["#A6CEE3", "#1F78B4", "#B2DF8A"],
        borderColor: ["#A6CEE3", "#1F78B4", "#B2DF8A"],
        borderWidth: 1,
      },
    ],
  };

  const legend = [
    { label: `Yet to Start: ${chartData.chartData.yet_to_start} %`, color: "#A6CEE3" },
    { label: `In Progress: ${chartData.chartData.in_progress} % `, color: "#1F78B4" },
    { label: `Attended: ${chartData.chartData.attended} % `, color: "#B2DF8A" },
  ];
  return (
    chartData.chartData.yet_to_start === 0 && chartData.chartData.in_progress === 0 && chartData.chartData.attended === 0
    ?<div> {`No ${chartData.ctx_labels.singular.student} has started attending this ${chartData.ctx_labels.singular.chapter.toLowerCase()}.`}</div>
    :<ChartDoughnut data={data} legend={legend} />
  );
};

const BubbleChart = ({ scatterData }) => {
  const theme = useTheme();
  const data01 = [...scatterData].map((entry) => {
    return {
      x: +entry.credit,
      y: entry.progress,
      r: 4,
      v: entry.name,
    };
  });
  const data = {
    // labels: "Title",
    datasets: [
      {
        // label: "Data",
        data: data01,
        backgroundColor: (context) => {
          return context.raw && context.raw.f === 1
            ? theme.color4
            : theme.color2;
        },
        hoverBackgroundColor: (context) => {
          return context.raw && context.raw.f === 1
            ? theme.color5
            : theme.color4;
        },
        hoverRadius: 1,
        hoverBorderWidth: 25,
        hoverBorderColor: rgba(theme.color2, 0.06),
      },
    ],
  };

  const footer = (tooltipItems) => {
    let credits = tooltipItems[0].raw.x;
    return "PLE: " + credits;
  };

  const title = (tooltipItems) => {
    let name = tooltipItems[0].raw.v;
    return name;
  };

  const label = (tooltipItem) => {
    let progress = tooltipItem.raw.y;
    return "%: " + progress;
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    interaction: {
      intersect: true,
      mode: "index",
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enable: false,
        // usePointStyle: true,
        displayColors: false,
        callbacks: {
          footer: footer,
          title: title,
          label: label,
          // beforeBody: () => "null",
        },
      },
    },

    scales: {
      y: {
        display: true,
        beginAtZero: true,
        suggestedMax: 100,
        ticks: {
          stepSize: 10,
        },
        grid: {
          borderColor: "rgba(39,45,54,0.3)",
          color: "rgba(0,0,0,0.1)",
        },
      },
      x: {
        display: true,
        beginAtZero: true,
        grid: {
          borderColor: "rgba(39,45,54,0.3)",
        },
      },
    },
  };

  return (
    <StyledChartWrapper>
      <div className="text-color2">Progress%</div>
      <div className="text-color2">PLE Credits</div>
      <Bubble data={data} options={options} />
    </StyledChartWrapper>
  );
};

function ChapterScatterChart(props) {
  return (
    <DashboardPanel
      title={props.ctx_user.user.type == 4 
        ? `Overall ${props.ctx_labels.plural.progress} `
        :`${props.ctx_labels.singular.trainee} ${props.ctx_labels.singular.leaderboard}`}
      fullScreen
    >
      <Card body className="border-0">
        {props.ctx_user.user.type == 4 ? (
          <ParentChart
            chartData={props.chart?.contents || []} 
            {...props}
          />
        ) : (
          <BubbleChart scatterData={props.data?.contents || []} />
        )}
      </Card>
    </DashboardPanel>
  );
}

ChapterScatterChart.propTypes = {};

export default withLabelsContext(withUserContext(ChapterScatterChart));
